export const COURSE_PAUSE_REQUEST_UPDATE_DURATION_OPTIONS = [
  {
    value: 1,
    label: '1 Month',
  },
  {
    value: 2,
    label: '2 Months',
  },
  {
    value: 3,
    label: '3 Months',
  },
];
